import script from "./DownloadButtonArtWorkCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadButtonArtWorkCategory.vue?vue&type=script&setup=true&lang=js"

import "./DownloadButtonArtWorkCategory.vue?vue&type=style&index=0&id=54d30e60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d30e60"]])

export default __exports__